import { Injectable } from '@angular/core';
import { DenominationOption, GiftCardV2 } from '~models';

@Injectable()
export class SelectOptionV2Service {
  public giftCard: GiftCardV2;
  public denomonationOptions: DenominationOption[];
  public selectedDenomination?: string | null;
  public isValidData = true;
  public isValidCustomAmount = true;
  public isCustomAmount = false;

  constructor() {}

  setSelectedCustomValue(price?: number | 'custom' | null) {
    if (!price) {
      this.selectedDenomination = null;
      return;
    }

    if (price === 'custom') {
      this.selectedDenomination = null;
      return;
    }

    this.selectedDenomination = price.toString().replace('$', '');
  }

  handleFocusInput(event: Event) {
    const input = event.target as HTMLInputElement;
    const inputParent = input.closest('.zip-row-input');

    inputParent.classList.add('is-inputed');
    inputParent.classList.add('is-focused');
  }

  handleBlurInput(event: Event) {
    const input = event.target as HTMLInputElement;
    const inputParent = input.closest('.zip-row-input');

    if (input.value === '') {
      inputParent.classList.remove('is-inputed');
    }
    inputParent.classList.remove('is-focused');
  }

  checkFieldsInput(inputs: HTMLInputElement[]) {
    for (let i = 0; i < inputs.length; i++) {
      if (inputs[i].value === '') {
        inputs[i].closest('.zip-row-input').classList.remove('is-inputed');
      } else {
        inputs[i].closest('.zip-row-input').classList.add('is-inputed');
      }
    }
  }
}
